import { render, staticRenderFns } from "./orderChecking.vue?vue&type=template&id=62960bea&scoped=true&"
import script from "./orderChecking.vue?vue&type=script&lang=ts&"
export * from "./orderChecking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62960bea",
  null
  
)

export default component.exports